export const enum OptionIds {
  lk_1m = 'lk_1m',
  lk_12m = 'lk_12m',
  lk_pro_1m = 'lk_pro_1m',
  lk_pro_3m = 'lk_pro_3m',
  lk_pro_6m = 'lk_pro_6m',
  lk_pro_12m = 'lk_pro_12m',
  promo_3m = 'promo_3m',
  promo_6m = 'promo_6m',
  promo_12m = 'promo_12m',
  stat_in_selection = 'stat_in_selection',
  main_feature = 'main_feature',
  redaction_week_plans = 'redaction_week_plans',
  redaction_partner = 'redaction_partner',
  without_promotion = 'without_promotion',
}

export type PromotionOption = {
  id: OptionIds
  price: number
  label: string
  longLabel: string
  discount?: number
  ownerSummaryLabel?: string
}

export const LK_OPTIONS: PromotionOption[] = [
  {
    id: OptionIds.lk_1m,
    price: 5000,
    label: '1 месяц',
    longLabel: 'Личный кабинет 1 месяц',
    ownerSummaryLabel: 'Тариф «Базовый» 1 месяц',
  },
  {
    id: OptionIds.lk_12m,
    price: 50000,
    label: '12 месяцев',
    longLabel: 'Личный кабинет 12 месяцев',
    ownerSummaryLabel: 'Тариф «Базовый» 12 месяцев',
  },
]

export const LK_PRO_OPTIONS: PromotionOption[] = [
  {
    id: OptionIds.lk_pro_1m,
    price: 8250,
    label: '1 месяц',
    longLabel: 'Личный кабинет PRO 1 месяц',
    ownerSummaryLabel: 'Тариф «ПРО» 1 месяц',
  },
  {
    id: OptionIds.lk_pro_3m,
    price: 24750,
    label: '3 месяца',
    discount: 10,
    longLabel: 'Личный кабинет PRO 3 месяца',
    ownerSummaryLabel: 'Тариф «ПРО» 3 месяца',
  },
  {
    id: OptionIds.lk_pro_6m,
    price: 49500,
    label: '6 месяцев',
    discount: 20,
    longLabel: 'Личный кабинет PRO 6 месяцев',
    ownerSummaryLabel: 'Тариф «ПРО» 6 месяцев',
  },
  {
    id: OptionIds.lk_pro_12m,
    price: 99000,
    label: '12 месяцев',
    discount: 30,
    longLabel: 'Личный кабинет PRO 12 месяцев',
    ownerSummaryLabel: 'Тариф «ПРО» 12 месяцев',
  },
]

export const calculateDiscountedPrice = (originalPrice: number, discount?: number) => {
  if (!discount || discount <= 0) return originalPrice
  return originalPrice * (1 - discount / 100)
}

export const PROMO_OPTIONS: PromotionOption[] = [
  { id: OptionIds.promo_3m, price: 32000, label: '3 месяца', longLabel: 'Промо 3 месяца' },
  { id: OptionIds.promo_6m, price: 52000, label: '6 месяцев', longLabel: 'Промо 6 месяцев' },
  { id: OptionIds.promo_12m, price: 91000, label: '12 месяцев', longLabel: 'Промо 12 месяцев' },
]

export const STATICS: PromotionOption[] = [
  { id: OptionIds.stat_in_selection, price: 20000, label: '7 дней', longLabel: 'Статика в подборке 7 дней' },
]

export const MAIN_FEATURE: PromotionOption[] = [
  {
    id: OptionIds.main_feature,
    price: 100000,
    label: '7 дней',
    longLabel: 'Фичер на главной 7 дней',
    ownerSummaryLabel: 'Фичер 7 дней',
  },
]

export const MATERIALS: PromotionOption[] = [
  {
    id: OptionIds.redaction_week_plans,
    price: 20000,
    label: 'Планы на неделю',
    longLabel: 'Планы на неделю',
  },
  {
    id: OptionIds.redaction_partner,
    price: 70000,
    label: 'Партнерский',
    longLabel: 'Партнерский материал',
  },
]

export type PromotionState = Partial<{
  lkOptions: PromotionOption[]
  promoOptions: PromotionOption[]
  statics: PromotionOption[]
  mainFeature: PromotionOption[]
  materials: PromotionOption[]
}>
